var map = {
	"./ClinicaMedica/17978.jpg": 1312,
	"./ClinicaMedica/17991.jpg": 1313,
	"./ClinicaMedica/18046.jpg": 1314,
	"./ClinicaMedica/19524.jpg": 1315,
	"./ClinicaMedica/24579.jpg": 1316,
	"./ClinicaMedica/24580.jpg": 1317,
	"./ClinicaMedica/24581.jpg": 1318,
	"./ClinicaMedica/553.jpg": 1319,
	"./ClinicaMedica/749.jpg": 1320,
	"./Pediatria/10540.jpg": 1321,
	"./Pediatria/17997.jpg": 1322,
	"./Pediatria/24569.jpg": 1323,
	"./Pediatria/24570.jpg": 1324,
	"./Pediatria/24572.jpg": 1325,
	"./Pediatria/24573.jpg": 1326,
	"./Pediatria/24574.jpg": 1327,
	"./Pediatria/24576.jpg": 1328,
	"./Pediatria/24577.jpg": 1329,
	"./Pediatria/25241.jpg": 1330,
	"./Pediatria/25829.jpg": 1331,
	"./Pediatria/426.jpg": 1332,
	"./Pediatria/670.jpg": 1333
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1311;


//////////////////
// WEBPACK FOOTER
// ./public/images ^\.\/.*\.jpg$
// module id = 1311
// module chunks = 0 1